import React, { useMemo } from 'react';
import { useScheduler } from './SchedulerContext';
import { getDaysInView, HEADER_HEIGHT, DAY_WIDTH } from '../utils/dateUtils';
import { format, isSameDay, isWeekend } from 'date-fns';
import clsx from 'clsx';

export const TimelineHeader: React.FC = () => {
  const { startDate, viewMode, endDate } = useScheduler();
  const days = getDaysInView(startDate, viewMode, endDate);
  const today = new Date();

  const totalWidth = days.length * DAY_WIDTH;

  const weeks = useMemo(() => {
    const result: { days: Date[]; label: string }[] = [];
    let tempDays: Date[] = [];

    for (let i = 0; i < days.length; i++) {
      tempDays.push(days[i]);

      if (days[i].getDay() === 0 || i === days.length - 1) {
        const startMonth = format(tempDays[0], 'MMM');
        const endMonth = format(tempDays[tempDays.length - 1], 'MMM');
        const label = startMonth === endMonth ? startMonth : `${startMonth} - ${endMonth}`;

        result.push({ days: [...tempDays], label });
        tempDays = [];
      }
    }

    return result;
  }, [days]);

  return (
    <div
      className="position-sticky top-0 bg-white border-bottom shadow-sm d-flex flex-column"
      style={{ height: HEADER_HEIGHT, zIndex: 99,width: totalWidth }} // minWidth: '100%'
    >
      <div className="d-flex flex-column" style={{ width: totalWidth }}>
        <div className="d-flex" style={{ height: '30px', borderBottom: '1px solid #eee' }}>
          {weeks.map((week: any, idx: any) => {
            const weekEndDay = week.days[week.days.length - 1];
            const isSunday = weekEndDay.getDay() === 0;
            const isCurrentWeek = week.days.some((day: any) => isSameDay(day, today));
            return (
              <div
                key={idx}
                className="d-flex align-items-center justify-content-center fw-bold small text-uppercase bg-white"
                style={{
                  width: week.days.length * DAY_WIDTH,
                  borderRight: isSunday ? '2px dotted #b0b0b0' : '1px solid #dee2e6',
                  borderTop: isCurrentWeek ? '2px solid #0d6efd' : undefined,
                }}
              >
                {week.label}
              </div>
            );
          })}
        </div>

        <div className="d-flex" style={{ height: '30px' }}>
          {days.map((day: any, i: any) => {
            const isToday = isSameDay(day, today);
            return (
              <div
                key={i}
                className={clsx(
                  "flex-shrink-0 d-flex align-items-center justify-content-center small",
                  isToday ? "bg-white bg-opacity-10 text-primary fw-bold" : "bg-white",
                  isWeekend(day) && !isToday && "bg-white text-danger"
                )}
                style={{ width: DAY_WIDTH, fontSize: '11px', borderRight: day.getDay() === 0 ? "2px dotted #b0b0b0" : "1px solid #dee2e6" }}
              >
                {isToday ? (
                  <div>
                    <span className='text-primary fw-bold'>{format(day, 'dd EEE')}</span>
                  </div>
                ) : (
                  <>
                    <span className='text-dark fw-bold'>{format(day, 'dd EEE')}</span>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};